module.exports = __webpack_public_path__ + "img/CompScope_Space_06.f1d9e097.png";